'use client';

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (error) {
    console.warn('Clipboard API failed. Falling back to execCommand.', error);
  }

  try {
    const span = document.createElement('span');
    span.textContent = text;
    span.style.whiteSpace = 'pre';
    span.style.position = 'fixed';
    span.style.left = '-9999px';
    span.style.top = '0';
    document.body.appendChild(span);

    const range = document.createRange();
    range.selectNodeContents(span);

    const selection = window.getSelection();
    const prevRanges: Range[] = [];
    if (selection) {
      for (let i = 0; i < selection.rangeCount; i += 1) {
        prevRanges.push(selection.getRangeAt(i));
      }
      selection.removeAllRanges();
      selection.addRange(range);
    }

    const successful = document.execCommand('copy');

    if (selection) {
      selection.removeAllRanges();
      for (const prev of prevRanges) selection.addRange(prev);
    }
    document.body.removeChild(span);
    return successful;
  } catch (error) {
    console.warn('Fallback clipboard copy failed.', error);
    return false;
  }
}

export function showManualCopyDialog(text: string) {
  try {
    // eslint-disable-next-line no-alert
    alert(`Transcription result:\n\n${text}`);
  } catch {
    /* ignored */
  }
}

